// iPhone Safari implements the Fullscreen API only for <video>, so
// Element.requestFullscreen is missing on every other element there
export const isNativeFullscreenSupported = (): boolean =>
  typeof document.documentElement.requestFullscreen === 'function';
